import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import 'babel-polyfill'
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/ticket.scss';
import '@/assets/main.scss';
import Table from "bootstrap-vue";
import axios from "axios";
import AuthActions from "@/store/actions/auth";
import * as Filters from '@/filters';
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import Datepicker from 'vuejs-datepicker';
import UserActions from '@/store/actions/profile'


Vue.config.productionTip = false;
Vue.use(BootstrapVue, Table, router, Filters, VueSweetalert2, Datepicker);
new Vue({
  router,
  store,
  render: (h) => h(App),

  beforeMount(){
    const token = localStorage.getItem('user-token');
    if(token) {
      axios.defaults.headers.common.Authorization = 'Bearer ' + token;
      //get user groups if we have a token
      this.$store.dispatch(UserActions.USER_PROFILE_REQUEST);
    }
  },

  created() {
    axios.interceptors.response.use(undefined, function (err) {
      let res = err.response;
      return new Promise(function (resolve, reject) {
        if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
          store.dispatch(AuthActions.AUTH_LOGOUT);
          router.push({ path: 'login' })
        }
        else if (res.status === 500){
          (Swal as any).fire({
            title: res.data.error,
            html:
                '<p id="error-message" style="font-size:12px">'+res.data.message.substring(0,150)+'...</p>' +
                '<span>If problem persists, please submit error message to help desk.</span>'
            ,
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(203, 203, 203)',
            confirmButtonText: 'Copy'
          }).then((result) => {
            if (result.value) {
              (navigator as any).clipboard.writeText(res.data.message)
                  .then(() => {
                    (Swal as any).fire(
                        'Copied!',
                        '',
                        'success'
                    )
                  })
                  .catch(err => {
                  });
            }
          })
        } else {
          throw err;
        }
      });
    });

  }
}).$mount('#app');




